import { defineMessage } from 'services/localization';

export const messages = {
    startOverSuccessText: defineMessage('the_approval_workflow_f_questname_has_restarted'),
    editStepParticipantsSuccessText: defineMessage('the_approvers_for_the_s__step_have_been_changed'),
    editStepReviewersSuccessText: defineMessage('reviewers_changed_for_review_step'),
    reassignRequestSuccessText: defineMessage('the_request_has_been_reassigned_to_displayname'),
    auditReportNotFoundNotificationText: defineMessage('the_audit_report_was_not_found'),
    attachmentNotFoundNotificationText: defineMessage('the_document_was_not_found'),
    cancelRequestSuccessText: defineMessage('the_request_has_been_cancelled'),
    makeForceDecisionApprovedSuccess: defineMessage('the_request_has_been_approved'),
    makeForceDecisionDeclinedSuccess: defineMessage('the_request_has_been_rejected'),
    makeDecisionApprovedSuccess: defineMessage('the_request_has_been_approved'),
    completeReviewSuccess: defineMessage('the_review_has_been_com__submitted_for_approval'),
    sendToReviewSuccess: defineMessage('the_request_has_been_returned_to_review'),
    makeDecisionDeclinedSuccess: defineMessage('the_request_has_been_rejected'),
    revokeRequestSuccess: defineMessage('the_approval_decision_has_been_revoked'),
    submitRequestSuccess: defineMessage('the_request_has_been_submitted_for_approval'),
    deleteRequestSuccess: defineMessage('the_request_has_been_deleted'),
    redirectToRequest: defineMessage('go_to_requestname'),
};
